// extracted by mini-css-extract-plugin
export var alt = "HotelMapMarker-module--alt--e2293";
export var desktopOnly = "HotelMapMarker-module--desktopOnly--9223a";
export var main = "HotelMapMarker-module--main--e1470";
export var mobileOnly = "HotelMapMarker-module--mobileOnly--1aa52";
export var styledSpinner = "HotelMapMarker-module--styledSpinner--d0335";
export var textLeft = "HotelMapMarker-module--textLeft--30219";
export var visuallyHidden = "HotelMapMarker-module--visuallyHidden--bdb55";